import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell
} from 'recharts';

import { useCallData } from '../../contexts/CallDataContext';
import { useWeek } from '../../contexts/WeekContext';
import { format, addDays, isWithinInterval, startOfDay, endOfDay, differenceInDays } from 'date-fns';

import { parseCustomTimestamp } from '../../utils/dateUtils';

const UnsuccessfulChart = () => {
    const { data } = useCallData();
    const { dateRange } = useWeek();

    // Process data to get unsuccessful calls per day for the selected date range
    const processCallData = () => {
        if (!dateRange || !dateRange.start || !dateRange.end) {
            return [];
        }

        // Calculate the number of days in the selected range
        const dayCount = differenceInDays(dateRange.end, dateRange.start) + 1;
        
        // Generate dates for the selected range
        const rangeDates = Array.from({ length: dayCount }, (_, i) => 
            addDays(dateRange.start, i)
        );
        
        const failedCallsPerDay = rangeDates.reduce((acc, date) => {
            acc[format(date, 'MM/dd')] = 0;
            return acc;
        }, {});

        // Count unsuccessful calls for each day in the selected range
        data.forEach(call => {
            const callDate = parseCustomTimestamp(call?.metadata?.timestamp); // Use the reusable function
            if (callDate) {
                const rangeStart = startOfDay(dateRange.start);
                const rangeEnd = endOfDay(dateRange.end);
                
                if (isWithinInterval(callDate, { start: rangeStart, end: rangeEnd }) && 
                    call.success_score !== null && call.success_score < 4) {
                    const formattedDate = format(callDate, 'MM/dd', { timeZone: 'UTC' });
                    if (failedCallsPerDay.hasOwnProperty(formattedDate)) {
                        failedCallsPerDay[formattedDate]++;
                    }
                }
            }
        });

        // Convert to array format for chart
        const chartData = rangeDates.map(date => ({
            date: format(date, 'MM/dd'),
            failed: failedCallsPerDay[format(date, 'MM/dd')]
        }));

        return chartData;
    };

    const chartData = processCallData();
    const totalFailed = chartData.reduce((sum, day) => sum + day.failed, 0);
    const maxValue = Math.max(...chartData.map(d => d.failed), 0); // Added 0 as fallback

    return (
        <div className="flex flex-col items-center card-container w-full h-[300px] space-y-2">
            <div className='flex flex-row w-full items-center justify-between'>
                <div className="text-sm text-font-primary mb-2">Unsuccessful Calls</div>
                <span className='text-lg font-semibold'>{totalFailed}</span>
            </div>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 10, right: 10, left: -30, bottom: -5 }}>
                    <XAxis dataKey="date" stroke="#b2b2b2" />
                    <YAxis stroke="#b2b2b2" />
                    <Tooltip />
                    <Bar dataKey="failed" radius={[8, 8, 8, 8]}>
                        {chartData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.failed === maxValue && maxValue > 0 ? "#c52233" : "#8c1823"}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default UnsuccessfulChart;
  
